var map = {
	"./alerts_icon_blue.png": 878,
	"./asset_icon_blue.png": 883,
	"./inventory_icon_blue.png": 607,
	"./item-types-management_icon_blue.png": 893,
	"./management-dashboard_icon_blue.png": 897,
	"./my-facility_icon_blue.png": 900,
	"./purchase-order_icon_blue.png": 905,
	"./shipments_icon_blue.png": 907,
	"./users_icon_blue.png": 916,
	"./work-order_icon_blue.png": 918
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2280;